





























































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import * as conf from '../config'
import { headings } from '../config'
import { details } from '../details'


export default Vue.extend({
    name: 'House1',
    props: ['step1', 'step2', 'step3'],
    data: () => ({
        dialog: false,
        region: false,
        component: 'cladding',
        parts: [
            {
                title: "The Roof Cladding",
                image: "2.png",
                text: "Wind pressures are applied to the roof cladding and forces are then transmitted through all the connections below it. Very high uplift forces are experienced at the edges of the roof.​",
                component: 'cladding',
                disabled: false,
                visible: true,
            },
            {
                title: "batten-to-rafter Connections",
                image: "6.png",
                text: "These hold the roof cladding securely to the rafters. These connections are often the weakest link in the hold down chain in older houses.",
                component: 'rafter',
                disabled: false,
                visible: true,

            },
            {
                title: "Ridgeline",
                image: "1.png",
                text: "The ridgeline connects the two sides of the roof together and experiences high uplift forces as wind moves over the apex of the roof​.",
                component: 'ridgeline',
                disabled: false,
                visible: true,
            },
            {
                title: "Internal Roof Connections",
                image: "7.png",
                text: "  ",
                component: 'internal',
                disabled: false,
                visible: true,

            },
            {
                title: "Roof to Wall Connections",
                image: "4.png",
                text: "These connections experience very high uplift forces as wind uplift forces try to lift the entire roof from the walls.​",
                component: 'wall',
                disabled: false,
                visible: true,

            },

            {
                title: "Wall to Floor Tie-Down",
                image: "5.png",
                text: "Forces at the top of the wall from uplift on the roof must safely reach the bottom of the wall and the floor to hold the house together.​",
                component: 'floor',
                disabled: false,
                visible: true,
            },
            {
                title: "Floor to Pier Connections",
                image: "3.png",
                text: "The final stage in the hold down chain for a high set house.​",
                component: 'pier',
                disabled: false,
                visible: true,
            },

        ],
        details: conf.config,
        headings: headings,
    }),
    mounted() {
        if(this.step3 == '0') {
            this.region = true;
            this.parts[5]['disabled'] = this.parts[6]['disabled'] = true;
            this.parts[5]['visible'] = this.parts[6]['visible'] = false;

        }

    }
})
